import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 30 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 15,
			fill: "#F4F2EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 11,
			r: 5,
			fill: "#BFB3A4"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 15,
			cy: 28,
			rx: 9,
			ry: 9,
			fill: "#BFB3A4"
		})
	]
});
export default SvgNoUser;
